<template>
    <table class="table table-hover bg-alt-yellow rounded my-3">
        <thead>
            <tr>
                <th scope="col">Post</th>
                <th>Type</th>
                <th>Created By</th>
                <th>Creation Date</th>
                <th>Published?</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="post in posts">
                <td><span>{{ post.title }}</span></td>
                <td><span>{{ post.type }}</span></td>
                <td><span>{{ post.user.username }}</span></td>
                <td><span v-text="this.Timestamp(post.created_at)"></span></td>
                <td><span v-text="this.Published(post.published)"></span></td>
                <td>
                    <button class="btn btn-warning" type="button"><a :href="`/admin/posts/edit/${ post.id }`">Edit</a></button>
                    <button v-if="this.filter == 'active'" @click="this.Delete(post.id)" class="btn btn-warning mx-2" type="button">Delete</button>
                    <button v-if="this.filter == 'deleted'" @click="this.Restore(post.id)" class="btn btn-warning mx-2" type="button">Restore</button>
                    <button v-if="post.published == false" @click="this.Publish(post.id)" class="btn btn-warning">Publish</button>
                    <button v-if="post.published == true" @click="this.Hide(post.id)" class="btn btn-warning">Hide</button>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>

import moment from 'moment';

export default {

    data () {
        return {
            posts: []
        }
    },

    created () {
        this.posts = this.items;
    },

    computed: {
        
    },

    methods: {
        Timestamp ( date ) {
            return moment(date).format('MMMM Do YYYY, hh:mm a');
        },

        Published ( $status ) {
            return $status == 1 ? 'Yes' : 'No';
        },

        async Publish ( id ) {
            const response = await axios.post(`/admin/post/publish`, { id: id });
            const key = this.posts.findIndex(a => a.id == id);
            this.posts[key].published = 1;
  		    window.Toast("Post Has Been Published");
        },

        async Hide ( id ) {
            const response = await axios.post(`/admin/post/hide`, { id: id });
            const key = this.posts.findIndex(a => a.id == id);
            this.posts[key].published = 0;
  		    window.Toast("Post Has Been Hidden");
        },

        async Delete ( id ) {
		    const response = await axios.post(`/admin/post/delete`, { id: id });
            const key = this.posts.findIndex(a => a.id == id);
            this.posts.splice(key, 1);
  		    window.Toast("Post Has Been Deleted");
	    },

	    async Restore ( id ) {
		    const response = await axios.post(`/admin/post/restore`, { id: id });
            const key = this.posts.findIndex(a => a.id == id);
            this.posts.splice(key, 1);
  		    window.Toast("Post Has Been Restored");
	    }

    },

    components: {

    },

    props: ['items', 'filter'],

}
</script>